module.exports = __webpack_public_path__ + "static/medullaco-logo-02cabadd944deca6886a2f5731eb76de.png";